import Fuse, { type IFuseOptions } from 'fuse.js';

import type { CatalogItem } from '@/entities/catalog-item';

// Token search splits multi-word queries and fuzzy-matches each term
// tokenMatch 'all' = every word must match somewhere
export const CATALOG_FUSE_OPTIONS: IFuseOptions<CatalogItem> = {
  keys: ['Code', 'Title', 'Alias'],
  threshold: 0.3,
  useTokenSearch: true,
  tokenMatch: 'all'
};

export function createCatalogFuse(items: CatalogItem[]): Fuse<CatalogItem> {
  return new Fuse(items, CATALOG_FUSE_OPTIONS);
}
